import React, { useState } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

// Components
import { DropzoneWrapper } from '../../components/fields/File';
import UploadedFile from './UploadedFile';
import DropzonePlaceholder from './DropzonePlaceholder';

// Translations
import messages from './messages';

const FeedbackUploader = ({
  categoryId,
  claimId,
  reasons,
  setReasons,
  feedbackOff = false,
  getRequirements,
  passengers = [],
  setUpdatedPassenger,
  setUpdatedPassengerId,
  updatedPassenger = false,
}: {
  categoryId: string;
  claimId: string | null;
  getRequirements?: () => void;
  reasons?: [];
  setReasons?: () => void;
  feedbackOff: boolean;
  passengers: any[];
  setUpdatedPassenger?: () => void;
  setUpdatedPassengerId?: () => void;
  updatedPassenger?: boolean;
}) => {
  const [progressPercentage, setProgressPercentage] = useState({});

  const { formatMessage } = useIntl();
  const { values, setFieldValue } = useFormikContext();

  return (
    <FieldArray
      name="files"
      // eslint-disable-next-line
      render={arrayHelpers => (
        <div className="flex flex-col sm:flex-row">
          <div
            className={clsx('sm:flex sm:justify-start sm:flex-wrap flex-grow', {
              'sm:max-w-half': !isEmpty(values?.files),
            })}
          >
            <div className="sm:mb-30 mb-15 sm:w-full">
              <DropzoneWrapper
                name="files"
                relationship={{
                  claim: { id: claimId },
                  category: { id: categoryId },
                }}
                categoryId={categoryId}
                placeholder={DropzonePlaceholder}
                arrayHelpers={arrayHelpers}
                values={values.files}
                setProgressPercentage={setProgressPercentage}
                setFieldValue={setFieldValue}
              />
            </div>
          </div>
          {!isEmpty(values?.files) ? (
            <div className="flex flex-col sm:pl-20 sm:flex-grow sm:max-w-half mb-25">
              <h3 className="text-gray-250 text-root font-semibold mb-10">
                {formatMessage(messages.uploadedFilesText)}
              </h3>
              {values?.files.map((item, index) =>
                item ? (
                  <UploadedFile
                    // eslint-disable-next-line
                    key={`file-${item.name}-${index}`}
                    file={item}
                    index={index}
                    setFieldValue={setFieldValue}
                    arrayHelpers={arrayHelpers}
                    reasons={reasons}
                    setReasons={setReasons}
                    formatMessage={formatMessage}
                    getRequirements={getRequirements}
                    progressPercentage={progressPercentage}
                    feedbackOff={feedbackOff}
                    setProgressPercentage={setProgressPercentage}
                    passengers={passengers}
                    claimId={claimId}
                    setUpdatedPassenger={setUpdatedPassenger}
                    setUpdatedPassengerId={setUpdatedPassengerId}
                    updatedPassenger={updatedPassenger}
                  />
                ) : null
              )}
            </div>
          ) : null}
        </div>
      )}
    />
  );
};

export default FeedbackUploader;
